import DayjsExtended from "@logic/DayjsExtended";

export const POST_APPROVAL_MINUTES_AHEAD = 30;
export const POST_SCHEDULE_MAX_DAYS_AHEAD = 30;
export const MS_TO_SHOW_WARNING = 7000;

export function isScheduledDateTooSoon(localDateTime: string): boolean {
  return DayjsExtended(localDateTime).isSameOrBefore(DayjsExtended().add(POST_APPROVAL_MINUTES_AHEAD, "minutes"));
}

export function getPostScheduleMinDate(): string {
  return DayjsExtended().add(POST_APPROVAL_MINUTES_AHEAD, "minutes").format("YYYY-MM-DDTHH:mm");
}

export function getPostScheduleMaxDate(): string {
  return DayjsExtended().add(POST_SCHEDULE_MAX_DAYS_AHEAD, "day").format("YYYY-MM-DDTHH:mm");
}
